import React from 'react'
import { format } from '../../../../../utils'

const EMPTY_PLACEHOLDER = '-'
const IN_PROGRESS = 'In Progress'

/**
 * Score Custom Cell Component
 * @param score
 * @returns {string}
 * @constructor
 */
const ScoreCell = ({ score }) => {
  if (score === IN_PROGRESS) {
    return score
  }

  const value = parseInt(score)
  return isNaN(value) ? EMPTY_PLACEHOLDER : `${format(value, 0)}%`
}

/**
 * AgGrid Custom Cell Render Component
 * @param data
 * @param column
 * @param onExpandMenuClick
 */
const CustomCell = ({ data = {}, column = {} }) => {
  const cellData = data[column.colId]

  switch (column.colId) {
    case 'full_name':
      return cellData || EMPTY_PLACEHOLDER
    case '_id':
      return cellData || EMPTY_PLACEHOLDER
    case 'score':
      return <ScoreCell score={cellData} />
    default:
      return cellData || EMPTY_PLACEHOLDER
  }
}

export default CustomCell
